import { createSlice } from '@reduxjs/toolkit';
import { IAppState } from '../../../types/storeTypes';
import { poll } from '../../../utils/Functions';
import { Dispatch } from 'redux';

const initialState: IAppState = {
  currency: '',
  localeId: '',
  countryCode: '',
  lunaAvailable: undefined,
  stadiaAvailable: undefined,
  windowVariablesInitialised: false
};

const app = createSlice({
  name: 'app',
  initialState: initialState,
  reducers: {
    setWindowVariables(state, action) {
      state.currency = action.payload.currency;
      state.localeId = action.payload.localeId;
      state.countryCode = action.payload.countryCode;
      state.lunaAvailable = action.payload.lunaAvailable;
      state.stadiaAvailable = action.payload.stadiaAvailable;
      state.windowVariablesInitialised = true;
    }
  }
});

const { setWindowVariables } = app.actions;

export default app.reducer;


/*Fetch necessary windows variables*/
export const fetchWindowVariables = () => {
  return async function(dispatch: Dispatch) {
    const windowVariablesPromises = await pollWindowVariables([
      'GeoRestrictedResources',
      'anywhereAvailability'
    ]);
    const promiseValues = await Promise.all(windowVariablesPromises);
    let variables = {
      currency :(promiseValues[0] as any).STOREFRONT_CURRENCY_CODE,
      localeId :(promiseValues[0] as any).STOREFRONT_CURRENT_LOCALE,
      countryCode :(promiseValues[0] as any).GEORESTRICTED_CURRENTSITE,
      lunaAvailable :(promiseValues[1] as any).luna_available,
      stadiaAvailable :(promiseValues[1] as any).stadia_available
    }
    dispatch(setWindowVariables(variables));
  };
}


export const pollWindowVariables = (properties: string[]) => {
  const promises = properties.map(property => {
    return new Promise(resolve => resolve(pollWindowVariable(property)));
  });

  return promises;
}

export const pollWindowVariable = async (
  property: string,
  timeout: number = 2000
) => {
  try {
    const w = window as any;
    await poll(
      () => {
        return w[property];
      },
      timeout,
      150
    );

    return w[property];
  } catch (error) {
    return null;
  }
};